var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyMinusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey-minus-icon",
    transform: "translate(7001 -6345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 16,
    height: 16,
    rx: 2,
    transform: "translate(-7001 6345)",
    fill: "#acb5c0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "add-icon",
    transform: "translate(-6997.486 6348.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-icon-2",
    "data-name": "add-icon",
    transform: "translate(4.268) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M3.351,3.018,5.967.4A.236.236,0,1,0,5.633.069L3.018,2.684l-.333.333L.069,5.633A.236.236,0,0,0,.4,5.967L3.018,3.351Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMinusIcon);
export default __webpack_public_path__ + "static/media/grey-minus-icon.08a35c68a45a3e35a03a2f040ddf39a2.svg";
export { ForwardRef as ReactComponent };